<template>
  <span class="">
    <template v-for="(p, pind) in object.payments">
      <span :key="`object-cashless-${object.id}-${pind}`" v-if="p.type == 'CASHLESS'">{{ formatCurrency(p.sell_sum / 100) }}</span>
    </template>
    <span v-if="object.payments.length == 0">0</span>
  </span>
</template>

<script>

import {formatCurrency} from "@/extensions/filters/filters"

export default {
  name: "CashdeskDatatableTDXReportCard",
  props: {
    object: {
      type: Object
    },
    field: {
      type: Object
    }
  },
  methods: {
    formatCurrency
  }
}
</script>
